import ProviderWrapper from './src/helpers/redux/ProviderWrapper';

export const wrapRootElement = ProviderWrapper;
